import Toast from 'react-native-toast-message'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SignatureFormView from '../SignatureFormView'

const VaInformationOnline = ({ navigation, route }: any) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postvaonline, loading } = useFormsStore()

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            personalExemptions: personalstore?.personalData?.maritalStatusValue == "S" ? 0 : 1,
            subTotalAgeExemptions: values?.subtotalforAge ? values?.subtotalforAge : null,
            totalExemptions: values?.totalExemptions ? values?.totalExemptions : null,
            additionalWithholding: values?.additionalwithholding ? values?.additionalwithholding : null,
            vawithholdingExempt: values?.va_withholding_exempt ? values?.va_withholding_exempt : null,
            smcrawithholdingExempt: values?.smcra_msra_exempt ? values?.smcra_msra_exempt : null,
            sign: signatureDataURL,
            TotalPersonalExemptions: values?.subtotalofpersonalExemptions ? values?.subtotalofpersonalExemptions : null,
        }
        const response = await postvaonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'VA Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('VaInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>

    )
}

export default VaInformationOnline
